import { IApplicationState } from '../../types/redux';

export const getNewbuildingReviewsStat = (state: IApplicationState) => {
  return state.newbuilding.reviews;
};
